import { render } from "./SocialLoginButtons.vue?vue&type=template&id=c265a03e&scoped=true"
import script from "./SocialLoginButtons.vue?vue&type=script&lang=js"
export * from "./SocialLoginButtons.vue?vue&type=script&lang=js"

import "./SocialLoginButtons.vue?vue&type=style&index=0&id=c265a03e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c265a03e"]])

export default __exports__